<template>
  <div class='container'>
      <ItemTab :renderData="initData"/>
  </div>
</template>

<script>
import ItemTab from '../components/item-tab.vue'
export default {
    name:'Index',
    components:{
        ItemTab
    },
    data() {
        return {
            initData:[
                {
                    'theme':'身份',
                    'data':[{key:'base',value:'用户基本信息'}]
                },
                {
                    'theme':'服务',
                    'data':[{key:'account',value:'账号信息'},{key:'works',value:'作品信息'},{key:'location',value:'位置信息'},{key:'social',value:'社交信息'}]
                },
                {
                    'theme':'设备',
                    'data':[{key:'device',value:'设备信息'}]
                }
            ]
        }
  },
  created(){
    document.title = '个人信息收集清单'
  }
}
</script>

<style lang="less" scoped>
  .container{
    background: #141414;
    min-height: 100vh;
    padding: 0.16rem;
  }
</style>
